import _ from 'lodash'
import React from 'react'
import styled from 'styled-components'
import { BiFilterAlt } from 'react-icons/bi'
import { Menu, MenuList, MenuButton, MenuItem } from '@reach/menu-button'
import '@reach/menu-button/styles.css'

import useCollection from '../competition-info/submission/hooks/useCollection'
import ExportToExcel from './ExportToExcel'
import DownloadMaterials from './DownloadMaterials'
import { MdOutlineDownloadForOffline } from 'react-icons/md'
import { FaSpinner } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'

function getProposalValue(object, id) {
  const isHtml = /<\/?[a-z][\s\S]*>/i.test(object[id])
  const textAreaValue = object[`${id}-plain`]
  const value = isHtml ? textAreaValue.slice(0, 500) : object[id]
  const formattedValue = requirementsValue(id, value)
  return formattedValue
}

const extraRequirementItem = {
  description: '',
  displayType: '',
  fileType: '',
  id: 'history',
  limit: '',
  name: 'Timestamp',
  required: false,
  type: 'text',
  unit: ''
}

// status: "valmis"
// timeStamp: "2022-12-02 15:32:30 UTC+2"
// title: "Luotu"

// const prizeProposalsId = [
//   '0266b5d2-5829-420c-b2b2-d5f7042cbb18', //Talas
//   '10b81537-5f17-4cb8-ad6a-0bedd3e0b75e', // Kumulus
//   '7e2c602d-3cb1-4f90-a2ac-f4ec28f2adda', // Corondum
//   '86a24a52-37b4-4b80-bfaa-4ba2bf5dfb40', // DELOREAN
//   '9d1b9361-157a-44c2-9090-d6a921db5a2b', // KUJA
//   '9ec5a080-33c0-4e03-84d3-d35476557450', // NOUSU TYRSKYKALLIOILLE
//   'a67bc632-d214-4dad-b388-bf289574ad49', // SKOPEO
//   'ac73f235-0cba-4d6d-a993-88bb090719b6', // EPOOKKI
//   'b0149359-f22b-4af2-a3fc-066b7379ca4c', // 132986
//   'bbf53468-de47-46b8-b578-3cf7d59925eb', // squama
//   'c607f281-469c-448d-93da-e980375c75ae', // KAHDEKSAS KUKKULA
//   'dad08b76-fb45-4cdb-ac6e-b507b8d625e7', // VIRTA
//   'e5ff1e70-6b93-4faf-9783-70e086935604', // Poetic Natures
//   'ebe45d5f-461b-42b6-9359-3fa7dfa16e27', // AURA (1)
//   'fec2bfa3-d52c-4f1d-800d-be0978730f06' // Airut
// ]

// const upperUpperClassProposalsIds = [
//   '02823998-4ce6-4e26-b7af-8e13feb45131', // Sticks and stones
//   '116b46ba-ac25-4f44-b68c-c7ebaaf54b04', // The Vessel
//   '21cf1a71-15c0-4f85-813d-42a85a6f57c2', // KHRONOS
//   '4d4e91c0-e32f-4b1d-9ff1-267d992ecfce', // Cu
//   '6edc0aac-188d-43b3-9ffc-fd572a411ac8', // Muistipalatsi
//   '7c125a9e-5491-496d-9913-43950b1864a3', // The City Connector
//   '7e130770-0fea-4bd6-8d80-42c921b5965b', // MAININKI
//   '942426ef-817a-4efc-bd51-40aff3df433e', // Polychromatic Superbox
//   'ab1e22ea-2b98-44df-b682-520bf406973b', // MATKUSTAJA
//   'b1c6adfc-b476-4eb5-8a10-4e51f1b90848', // STONE FUTURE
//   '07566728-db5e-40b0-a95c-3eead1f5c3f7', // Waves of time
//   '1dd8e24f-d1f4-4c72-add1-391ffb355772', // Maritime Pine
//   '2adedc24-b314-4b6a-ac7f-6206708ae82f', // Sisäpiha
//   '2dc6c4b1-968e-4bde-a9b4-fd965198f11b', // rantakallio
//   '35b74a50-2a3f-44b2-973b-756bc8e2211c', // LANTERNI
//   '48f9ebfb-91d3-44c4-8349-a0d23b8f038a', // MALMIEN KIILTO
//   '4eaad723-cea4-4550-9121-a3d369ffae31', // GoMuHiFu
//   '558012fb-af6c-470f-8e84-befe299291c5', // KUAKKA
//   '93e2f35f-be07-42c3-aa9e-7aa6ac5012a6', // VEDENEMO
//   '94f1398b-a96c-4fc1-8527-36116535e2cc', // ORION
//   'a97120e3-1b16-4c07-9e02-249ab4f8dcab', // Kangastus
//   'b2ce57a2-ee2a-4fa0-a6aa-82b8aeed1497', // Aura Temporis
//   'b3131474-d5f0-46be-bf70-c6afcf7399d4', // JATKUMO
//   'b3baee29-4950-433d-b4d1-0fdb13b91bed', // 425282
//   'c0783681-93e0-4c34-a0f9-f8b7a97abe14', // Longhouse Platform
//   'd39fb150-7384-41c4-b986-509ead8c9f37', // ARCHI_PELAGO
//   'd3a3946f-8fa6-499a-8341-cc6c6e915660', // 15012024
//   'd540d352-04e8-489a-931d-89b8df74f99c', // The Wave
//   'f64feb92-25c6-4ea0-b77e-281f0cab8af2', // Imaginary Time
//   'ff30a8d9-4015-435d-9f4a-d2131265975a', // aib61
//   'db699e83-de66-44ec-b942-b4066e0d69ab' // Tulevaisuuden paino
// ]

const requiredProposalsIds = [
  '21cf1a71-15c0-4f85-813d-42a85a6f57c2', // KHRONOS
  '6edc0aac-188d-43b3-9ffc-fd572a411ac8', // Muistipalatsi
  '7e130770-0fea-4bd6-8d80-42c921b5965b', // MAININKI
  'ab1e22ea-2b98-44df-b682-520bf406973b', // MATKUSTAJA
  'b3baee29-4950-433d-b4d1-0fdb13b91bed' // 425282
]

export default function SubmissionStatusTable() {
  const { documents: allProposals } = useCollection('sub-b-proposals')
  const { documents: info } = useCollection('info')
  const [proposals, setProposals] = React.useState({})
  const { t } = useTranslation('proposals')

  React.useEffect(() => {
    if (!!allProposals) {
      setProposals(allProposals)
    }
  }, [allProposals])

  if (!allProposals || !info) {
    return (
      <Wrapper>
        <h1>{t('Submitted proposals')}: 0</h1>
      </Wrapper>
    )
  }

  const getProposalsByIds = ids => {
    const result = Object.entries(allProposals).filter(([id, proposal]) => {
      return ids.includes(id)
    })

    return Object.fromEntries(result)
  }

  const shapeRequirements = () => {
    const hasData = info?.submission?.items?.length > 0

    if (hasData) {
      const items = info?.submission?.items.map(item => item)
      items.push(extraRequirementItem)
      return items
    }
    return info?.submission?.items
  }
  const requirements = shapeRequirements()
  const competitionName = info?.general?.name
  const submissionDeadline = info?.general?.deadline

  const selectedProposals = getProposalsByIds(requiredProposalsIds)

  const shapeExcelData = () => {
    let data = []

    requirements.forEach(({ id, name }) => {
      Object.values(selectedProposals).forEach((proposal, index) => {
        const proposalName = !!proposal.pseudonym
          ? proposal.pseudonym
          : `${t('Proposal')} ${index + 1}`
        // const formattedValue =
        //   id !== '9f0de760-b5b5-4277-bbe6-70d42418ce7c'
        //     ? getProposalValue(proposal, id)
        //     : ''

        data.push({
          Proposal: proposalName,
          Class: '',
          Rate: ''
        })
      })
    })
    const groupedData = mergeObjects(data, 'Proposal')

    return groupedData
  }

  const excelData = !!requirements ? shapeExcelData() : []
  console.log('excelData:', excelData)

  const generateWscols = () => {
    const headers = Object.values(proposals).map((proposal, index) => {
      const proposalName = !!proposal.pseudonym
        ? proposal.pseudonym
        : `${t('Proposal')} ${index + 1}`
      return proposalName
    })
    const firstColumn = [
      {
        wch: Math.max(...excelData.map(col => col.Proposal.length))
      }
    ]
    const columns = headers.map(header => ({
      wch: Math.max(...excelData.map(col => (!!col[header] ? 50 : 0)))
    }))

    return [...firstColumn, ...columns]
  }

  // const filteredProposals = key => {
  //   const result = Object.entries(allProposals).filter(([id, proposal]) => {
  //     if (key !== 'all' && proposal.proposalStatus === key) {
  //       return [id, proposal]
  //     }

  //     if (key === 'all') {
  //       return [id, proposal]
  //     }
  //   })
  //   setProposals(Object.fromEntries(result))
  // }
  const filteredProposals = key => {
    const result = Object.entries(allProposals).filter(([id, proposal]) => {
      return key === 'all' || proposal.proposalStatus === key
    })
    setProposals(Object.fromEntries(result))
  }

  const getMaterialDownloadUrls = () => {
    const selectedProposals = getProposalsByIds(requiredProposalsIds)
    console.log('selectedProposals:', selectedProposals)
    const arrays = Object.values(selectedProposals).map((proposal, index) => {
      let urls = []
      const { pseudonym, history } = proposal
      const submittedDate = history[history.length - 1]['timeStamp']
      const proposalName = !!pseudonym
        ? `${pseudonym}-${submittedDate}`
        : `${t('Proposal')} ${index + 1}`

      Object.entries(proposal).forEach(([key, value]) => {
        if (_.isObject(value) && !_.isEmpty(value) && !!value.downloadUrl) {
          urls.push({
            pseudonym: proposalName,
            downloadUrl: value.downloadUrl,
            fileName: value.fileName,
            proposalId: proposal.id
          })
        }
      })

      return urls
    })

    return arrays.flat(1)
  }

  return (
    <div>
      <Wrapper>
        <h1>
          {t('Submitted proposals')}: {Object.keys(allProposals).length}
        </h1>
        <div style={{ display: 'flex', gap: 5 }}>
          <FilterOptions handleFilter={filteredProposals} />
          <ExportOptions
            excelData={excelData}
            submissionDeadline={submissionDeadline}
            fileName={`${competitionName} Qualification Table`}
            wscols={generateWscols()}
            urls={getMaterialDownloadUrls()}
          />
        </div>
      </Wrapper>
      <div style={{ marginBottom: 16 }}>
        <h2 style={{ marginBottom: -5, fontSize: '0.9rem' }}>
          {t('Incomplete proposals')}:{' '}
          {
            Object.values(allProposals).filter(
              proposal => proposal.proposalStatus === 'keskeneräinen'
            ).length
          }
        </h2>
        <h2 style={{ marginBottom: 0, fontSize: '0.9rem' }}>
          {t('Complete proposals')}:{' '}
          {
            Object.values(allProposals).filter(
              proposal => proposal.proposalStatus !== 'keskeneräinen'
            ).length
          }
        </h2>
      </div>
      <ProposalsTable tableData={proposals} requirements={requirements} />
    </div>
  )
}

function ProposalsTable({ tableData, requirements }) {
  const { t } = useTranslation('proposals')

  const TableHeader = (
    <thead>
      <TableRow>
        <TableHead>Soveltuvuusvaatimukset</TableHead>
        {Object.entries(tableData).map(
          ([id, { pseudonym, proposalStatus }], index) => (
            <TableHead key={id}>
              {!!pseudonym ? (
                <ProposalNameWrapper>
                  <div>{pseudonym}</div>
                  <Status status={proposalStatus}>{proposalStatus}</Status>
                </ProposalNameWrapper>
              ) : (
                <ProposalNameWrapper>
                  <span>{`${t('Proposal')} ${index + 1}`}</span>
                  <Status status={proposalStatus}>{proposalStatus}</Status>
                </ProposalNameWrapper>
              )}
            </TableHead>
          )
        )}
      </TableRow>
    </thead>
  )

  return (
    <TableWrapper>
      <Table>
        {TableHeader}
        <tbody style={{ verticalAlign: 'top' }}>
          {!!requirements
            ? requirements.map(({ id, name }) => (
                <TableRow key={id}>
                  <TableBodyHeader>{t(name)}</TableBodyHeader>
                  {Object.values(tableData).map((proposal, index) => {
                    const cellValue = getProposalValue(proposal, id)
                    const cell = Array.isArray(cellValue) ? (
                      <TableCell key={index}>
                        {cellValue.map((value, cellValueIndex) => {
                          return (
                            <div
                              style={{
                                marginBottom: 10
                              }}
                            >
                              {cellValueIndex > 0 ? (
                                <span style={{ display: 'inline-block' }}>
                                  -
                                </span>
                              ) : null}
                              {Object.entries(value).map(
                                ([name, value], index) => {
                                  if (typeof value !== 'object') {
                                    return (
                                      <p
                                        key={index}
                                        style={{
                                          marginTop: 0,
                                          marginBottom: 5
                                        }}
                                      >
                                        {name}: {value}
                                      </p>
                                    )
                                  }
                                  return (
                                    <p
                                      key={index}
                                      style={{ marginTop: 0, marginBottom: 10 }}
                                    >
                                      {name} {Object.keys(value)[0]}:{' '}
                                      {Object.values(value)[0]}
                                    </p>
                                  )
                                }
                              )}
                            </div>
                          )
                        })}
                      </TableCell>
                    ) : (
                      <TableCell key={index}>
                        {id === '9f0de760-b5b5-4277-bbe6-70d42418ce7c' &&
                        cellValue
                          ? 'Tekijät'
                          : cellValue}
                      </TableCell>
                    )
                    return cell
                  })}
                </TableRow>
              ))
            : null}
        </tbody>
      </Table>
    </TableWrapper>
  )
}

const requirementsValue = (id, value) => {
  let formattedValue = value

  if (_.isEmpty(value)) {
    return null
  }

  if (Object.keys(value).includes('fileName')) {
    return (formattedValue = !_.isEmpty(value) ? value.fileName : '')
  }

  if (id.includes('table-')) {
    return (formattedValue = !_.isEmpty(value)
      ? Object.entries(value).map(([name, data]) =>
          !!data ? { [name]: data } : {}
        )
      : '')
  }

  return formattedValue
}

// const createString = (array, glue = ': ', separator = ', ') =>
//   array
//     .map(object =>
//       Object.entries(object).map(([key, value]) => {
//         return [key, value].join(glue)
//       })
//     )
//     .join(separator)

function mergeObjects(array, key) {
  const res = array.reduce((acc, obj) => {
    let found = false
    for (let i = 0; i < acc.length; i++) {
      if (acc[i][key] === obj[key]) {
        found = true
        Object.assign(acc[i], obj)
      }
    }
    if (!found) {
      acc.push(obj)
    }
    return acc
  }, [])
  return res
}

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  user-select: text;

  h1 {
    margin-bottom: 0;
    font-size: 1.1rem;
  }
`

const TableWrapper = styled.div`
  overflow: auto;
  user-select: text;
`

const Table = styled.table`
  white-space: nowrap;
  margin: 0;
  border: none;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
  /* width: 100%; */
`

const TableRow = styled.tr`
  border-bottom: 1px solid #d8e0e4;
`

const TableHead = styled.th`
  padding: 16px 25px 16px 25px;
  background-color: #d8e0e4;
  position: sticky;
  top: 0;
  min-width: 250px;
  /* z-index: 1; */

  &:first-child {
    min-width: 400px;
    text-align: left;
    position: sticky;
    left: 0;
    z-index: 2;
    /* padding-left: 0px; */
  }
`

const TableCell = styled.td`
  padding: 16px 25px 16px 25px;
  white-space: break-spaces;
  hyphens: auto;

  &:nth-child(odd) {
    background-color: #eff2f3;
  }
`

const TableBodyHeader = styled.th`
  position: sticky;
  left: 0;
  padding: 16px 25px 16px 25px;
  text-align: left;
  background-color: #fff;
  z-index: 1;
  white-space: break-spaces;
`

const ProposalNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Status = styled.div`
  max-width: max-content;
  margin-top: 10px;
  padding: 5px 10px;
  background-color: ${({ status }) =>
    status === 'keskeneräinen' ? 'red' : 'green'};
  color: #fff;
`

function FilterOptions({ handleFilter }) {
  const { t } = useTranslation('proposals')

  return (
    <Menu>
      <StyledMenuBUtton>
        <BiFilterAlt style={{ width: 18, height: 18, marginRight: 5 }} />
        <span>{t('Filters')}</span>
      </StyledMenuBUtton>
      <MenuList>
        <StyledMenuItem onSelect={() => handleFilter('all')}>
          {t('All')}
        </StyledMenuItem>
        <StyledMenuItem onSelect={() => handleFilter('keskeneräinen')}>
          {t('Incomplete')}
        </StyledMenuItem>
        <StyledMenuItem onSelect={() => handleFilter('valmis')}>
          {t('Complete')}
        </StyledMenuItem>
      </MenuList>
    </Menu>
  )
}

const StyledMenuBUtton = styled(MenuButton)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #d8e0e4;
  border-radius: 5px;
  padding: 8px 10px;
  font-weight: bold;
  color: #fff;
  background-color: #3f51b5;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #303e8e;
  }
`

const StyledMenuItem = styled(MenuItem)`
  &[data-selected] {
    color: #fff;
    background-color: #3f51b5;
  }
`

function ExportOptions({
  excelData,
  fileName,
  wscols,
  submissionDeadline,
  urls
}) {
  const [loading, setLoading] = React.useState(false)
  const { t } = useTranslation('proposals')

  return (
    <Menu>
      <StyledMenuBUtton>
        {loading ? (
          <Spinner />
        ) : (
          <MdOutlineDownloadForOffline
            style={{ width: 18, height: 18, marginRight: 5 }}
          />
        )}
        <span>{t('Export')}</span>
      </StyledMenuBUtton>
      <MenuList>
        <StyledMenuItem onSelect={() => {}}>
          <ExportToExcel
            excelData={excelData}
            fileName={fileName}
            wscols={wscols}
            submissionDeadline={submissionDeadline}
          />
        </StyledMenuItem>
        <StyledMenuItem onSelect={() => {}}>
          <DownloadMaterials
            urls={urls}
            setLoading={setLoading}
            fileName={fileName}
          />
        </StyledMenuItem>
      </MenuList>
    </Menu>
  )
}

const Spinner = styled(FaSpinner)`
  width: 18px;
  height: 18px;
  margin-right: 5px;
  animation: spin 1s infinite linear;

  @keyframes spin {
    from {
      transform: scale(1) rotate(0deg);
    }
    to {
      transform: scale(1) rotate(360deg);
    }
  }
`
